<template>
  <el-container>
    <el-main class="main">
      <div class="admin">
        <el-link type="info" href="https://panel.editello.com">Panel</el-link>
      </div>
      <el-row>
        <Headline />
        <div v-if="categories.length > 1" class="categories">
          <div
            class="category"
            :class="{ 'active': filterCategory === category.id }"
            v-for="category in categories"
            :key="category.id"
            @click="filterByCategory(category)"
          >
            {{ category.name }}
          </div>
        </div>
        <el-row class="tiles" :gutter="20">
          <el-col
            :xs="24"
            :sm="12"
            :md="8"
            :lg="4"
            v-for="(template, index) in filteredTemplates"
            :key="index"
          >
            <TemplateTile :template="template" />
          </el-col>
        </el-row>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import Headline from '../components/Home/Headline.vue';
import TemplateTile from '../components/Home/TemplateTile.vue';
import { GraphQLClient, gql } from 'graphql-request';

export default {
  name: 'Home',
  data() {
    return {
      error: false,
      loading: true,
      templates: [],
      filterCategory: null
    };
  },
  computed: {
    categories() {
      const categories = []

      this.templates.forEach((template) => categories.push(...(template.categories || [])))

      return [...new Map(categories.map((category) => [category.id, category])).values()]
    },
    filteredTemplates() {
      return this.templates.filter((template) => {
        
        if (this.filterCategory === null || !template.categories) {
          return true
        }

        return template.categories.map((category) => category.id).includes(this.filterCategory)
      })
    }
  },
  methods: {
    filterByCategory(category) {
      this.filterCategory = (this.filterCategory === category.id ? null : category.id)
    }
  },
  async mounted() {
    
    const endpoint = location.hostname !== 'localhost' ? `https://editello.com/graphql` : 'http://localhost:8082/graphql'

    const graphQLClient = new GraphQLClient(endpoint, {
      credentials: 'include',
      mode: 'cors',
      headers: {
        // authorization: 'Bearer MY_TOKEN',
      },
    })

    const query = gql`
      {
        drafts {
          name,
          code,
          preview,
          categories {
            id,
            name
          }
        }
      }
    `

    const data = await graphQLClient.request(query)

    this.loading = false;
    this.templates = data.drafts;
  },
  components: {
    Headline,
    TemplateTile,
  },
};
</script>

<style lang="less" scoped>
p {
  max-width: 500px;
  margin: 15px auto 30px;
  color: rgb(146, 146, 146);
}

.tiles {
  display: flex;
  flex-wrap: wrap;
  margin: 0 !important;
}

.el-row {
  width: 100%;
}

.el-col {
  margin-bottom: 25px;
}

.categories {
  display: flex;
  margin: 0 auto;
  margin-bottom: 50px;
  margin-top: 50px;
  overflow: auto;

  @media (min-width: 768px) {
    max-width: 60%;
    justify-content: center;
  }
}

.category {
  background: #fff;
  cursor: pointer;
  padding: 10px 20px;
  border-radius: 3px;
  transition: background .3s;
  white-space: nowrap;

  &:hover {
    background: #f5f5f5;
  }

  &.active {
    background: #409EFF;
    color: #fff;
  }

  + .category {
    margin-left: 10px;
  }
}

.el-main.main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  .admin {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 1;
  }
}
</style>
